import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TextInput from 'atoms/TextInput'

export default class ProposalFieldOptionInput extends Component {
  static propTypes = {
    onOptionAdd: PropTypes.func.isRequired,
  }

  state = {
    value: ''
  }

  handleChange = (ev) => {
    const { value } = ev.target
    this.setState({ value })
  }

  handleEnterPress = () => {
    const { onOptionAdd } = this.props
    const { value } = this.state
    if (value) {
      this.setState({ value: '' }, () => {
        onOptionAdd(value)
      })
    }
  }

  render() {
    const { onOptionAdd, ...rest } = this.props
    const { value } = this.state
    return (
      <TextInput
        {...rest}
        multiline
        maxLength={30}
        value={value}
        onChange={this.handleChange}
        onEnterPress={this.handleEnterPress}
      />
    )
  }
}
